import { CONFLICT_RESOLUTION_EMAIL } from "@app/shared/constants";
import { Link, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { routes } from "app/routes";
import DocumentContext from "components/DocumentContext";
import PageWrapper from "components/PageWrapper";
import { NavLink } from "features/navigation/NavLink";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
    },
}));

export const ConflictResolutionPage = () => {
    const classes = useStyles();

    return (
        <PageWrapper className={classes.root}>
            <DocumentContext title="Navigating Issues with Care" addBrandNameSuffix />
            <Typography variant="h1">Confidential Support For Conflicts &amp; Concerns</Typography>

            <Typography variant="body1">
                Within our global community, we’re coming from a variety of backgrounds and life
                experiences. In order to create an environment where we can build trust and share
                authentically &amp; vulnerably, it’s important to have some shared agreements about
                how to relate mindfully. Our{" "}
                <NavLink to={routes.communityGuidelines()}>
                    Community Guidelines for Mindful Relating
                </NavLink>{" "}
                help to guide and connect us along this journey.
            </Typography>
            <Typography variant="body1">
                For many of us, practicing wise speech and deep listening is a skill we haven’t been
                taught. Even when we have been taught, it takes lots of practice, and we can't
                expect ourselves or others to be perfect. That said, if you experience something in
                a session that feels inappropriate or unsafe, please reach out to us confidentially
                at{" "}
                <NavLink href={`mailto:${CONFLICT_RESOLUTION_EMAIL}`}>
                    {CONFLICT_RESOLUTION_EMAIL}
                </NavLink>
                . We're here to offer support. 🙏🏾💗
            </Typography>
        </PageWrapper>
    );
};

export default ConflictResolutionPage;
